import { isEmpty } from 'common/js/global-utils'

export default class {
    /**
     * Token constructor
     * @param token (a token with at least accessToken, refreshToken and expiration keys)
     */
    constructor (token) {
        this._accessToken = token.accessToken
        this._refreshToken = token.refreshToken
        this._expirationDate = token.expirationDate
    }

    get accessToken () {
        return this._accessToken
    }

    set accessToken (accessToken) {
        this._accessToken = accessToken
    }

    get refreshToken () {
        return this._refreshToken
    }

    set refreshToken (refreshToken) {
        this._refreshToken = refreshToken
    }

    get expirationDate () {
        return this._expirationDate
    }

    set expirationDate (expirationDate) {
        this._expirationDate = expirationDate
    }

    getGmtExpirationDate () {
        return new Date(this.expirationDate * 1000).toGMTString()
    }

    /**
     * Return remaining seconds before the token expires (return -1 if the token is empty)
     * @returns {number}
     */
    getRemainingTime (message) {
        if (!isEmpty(this.accessToken) && !isEmpty(this.expirationDate)) {
            let now = new Date()
            // let expirationDateTimestamp = (now.getTime() + 1800000) / 1000//this.expirationDate
            let expirationDateTimestamp = this.expirationDate

            // let expirationDate = new Date(now.getTime() + 70 * 1000) // Set expiration in 70sec
            // expirationDateTimestamp = expirationDate.getTime() / 1000

            let remainingTime = expirationDateTimestamp - now.getTime() / 1000
            let exp = new Date(expirationDateTimestamp * 1000)
            // console.log((!isEmpty(message) ? message + ' ' : '') + (remainingTime > 0 ? 'Token will expire in ' + Math.floor(remainingTime) + ' seconds' : 'Token has expired ' + Math.abs(Math.floor(remainingTime)) + ' seconds ago') + ', on ' + exp)

            return remainingTime > 0 ? remainingTime : 0
        }
        return -1
    }

    toString () {
        return `${this.accessToken.substring(this.accessToken.length - 10)} | ${new Date(this.expirationDate * 1000)} | ${this.refreshToken.substring(this.refreshToken.length - 10)}`
    }
}
